<template>
  <div class="per-capita-output-ranking" ref="chartRef" style="width: 100%; height: 300px;"></div>
</template>

<script>
import * as echarts from 'echarts'
import { getPerCapitaOutputRanking } from "../api";
import { extractTitleAndValueArrays } from "@/basic-common/util/common";
export default {
  name: 'PerCapitaOutputRanking',
  inject: ['parentThat'],
  data () {
    return {
      chart: null
    };
  },
  mounted () {
    this.chart = echarts.init(this.$refs.chartRef);
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize);
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    initChart () {
      const { queryForm } = this.parentThat
      getPerCapitaOutputRanking(queryForm).then(({ data }) => {
        const dataAll = extractTitleAndValueArrays(data.data, 'teamName', 'perCapitaOutput')
        this.setOption(dataAll.values, dataAll.titles)
      })
    },
    setOption (data, title) {
      const option = {
        title: {
          text: '人均产出排名',
          left: '10%',
          top: '5%'
        },
        xAxis: {
          type: 'value',
          max: 30
        },
        yAxis: {
          type: 'category',
          data: title,
          inverse: true
        },
        series: [
          {
            type: 'bar',
            data: data,
            itemStyle: {
              color: '#4895ef'
            },
            barWidth: '60%'
          }
        ],
        grid: {
          left: '15%',
          right: '10%',
          top: '20%',
          bottom: '10%'
        }
      };
      this.chart.setOption(option);
    },
    handleResize () {
      if (this.chart) {
        this.chart.resize();
      }
    }
  }
};
</script>